import React from 'react'
import I18n from 'resources/i18n/I18n'
import './pagination.scss'

const Pagination = ({ totalCount, translationKey, pages, currentPage, onChange }) => {
  // Function to handle page change logic
  const handlePageChange = (page) => {
    if (page >= 0 && page < pages) {
      onChange(page)
    }
  }

  return (
    <nav>
      <ul className="pagination">
        {totalCount > 0 && (
          <span className="primary-text-color d-flex align-items-center mr-3">
            {totalCount} {I18n.t(`${translationKey}${totalCount > 1 ? 's' : ''}`)}
          </span>
        )}

        {/* First Page Button */}
        <li className="page-item ml-1">
          <button className="page-link" onClick={() => handlePageChange(0)} disabled={currentPage === 0}>
            <span className="icon-angle-double-left" />
          </button>
        </li>

        {/* Previous Page Button */}
        <li className="page-item ml-1">
          <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0}>
            <span className="icon-angle-left" />
          </button>
        </li>

        {/* Current Page */}
        <li className={`page-item ml-1 ${currentPage > 0 ? '' : 'd-none'}`}>
          <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
            {currentPage}
          </button>
        </li>

        {/* Active Page */}
        <li className="page-item ml-1">
          <button className="page-link active">{currentPage + 1}</button>
        </li>

        {/* Next Page */}
        <li className={`page-item ml-1 ${currentPage < pages - 1 ? '' : 'd-none'}`}>
          <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
            {currentPage + 2}
          </button>
        </li>

        {/* Next Page Button */}
        <li className="page-item ml-1">
          <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= pages - 1}>
            <span className="icon-angle-right" />
          </button>
        </li>

        {/* Last Page Button */}
        <li className="page-item ml-1">
          <button className="page-link" onClick={() => handlePageChange(pages - 1)} disabled={currentPage >= pages - 1}>
            <span className="icon-angle-double-right" />
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default Pagination
